import type { MinMax } from '../../core/types/min-max.js';
import type {
  CategoryName,
  SeriesId,
  RectSeriesIdToValueScaleDomain,
} from '../types/xy-chart-internals.js';

type ValueScaleDomainArgs = {
  seriesIdToValueScaleDomain: RectSeriesIdToValueScaleDomain;
  seriesId: SeriesId;
  value: number | string;
};

type ValueScaleDomainByType = {
  number: (args: ValueScaleDomainArgs) => MinMax;
  string: (args: ValueScaleDomainArgs) => Set<CategoryName>;
};

const valueScaleDomainByType: ValueScaleDomainByType = {
  number: (args) => {
    const minMaxValue = (args.seriesIdToValueScaleDomain.get(args.seriesId) ?? {
      min: Infinity,
      max: -Infinity,
    }) as MinMax;

    minMaxValue.min = Math.min(minMaxValue.min, args.value as number);
    minMaxValue.max = Math.max(minMaxValue.max, args.value as number);
    return minMaxValue;
  },
  string: (args) => {
    const categorySet = (args.seriesIdToValueScaleDomain.get(args.seriesId) ??
      new Set()) as Set<CategoryName>;

    categorySet.add(args.value as string);

    return categorySet;
  },
};

export function getValueScaleDomain(
  value: string | number,
  seriesId: SeriesId,
  seriesIdToValueScaleDomain: RectSeriesIdToValueScaleDomain,
) {
  return valueScaleDomainByType[typeof value as 'number' | 'string']({
    seriesIdToValueScaleDomain,
    seriesId,
    value,
  });
}
